import { Box, IconButton, Image, Link, Text } from "@chakra-ui/react";
import { ReactSVG } from "react-svg";
import NextLink from "next/link";

type HeaderProps = React.PropsWithChildren<{
  centered?: Boolean;
}>;

const Header: React.FC<HeaderProps> = ({ children, centered }) => {
  return (
    <>
      <Box
        p={{ base: "4", sm: "10" }}
        as="header"
        display="flex"
        justifyContent="space-between"
      >
        <Box maxWidth="1280px" margin="0 auto">
          <Link href="/">
            <ReactSVG src="/images/PraiselyLogoMark.svg" />
          </Link>
        </Box>
      </Box>
    </>
  );
};

export default Header;
